import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo, ERate } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'general-knowledge',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './general-knowledge.component.html',
  styleUrl: './general-knowledge.component.css'
})
export class GeneralKnowledgeComponent implements OnInit {

  @Input() studentInterviewData: any;
  @Output() onSaveSection7 = new EventEmitter<any>();

  rate = ERate;
  yesNo = EYesNo;
  generalKnowledgeForm: FormGroup = new FormGroup({});
  questionList = [
    {
      question: "Does the student know who the president is? *",
      formControlName: "president",
    },
    {
      question: "Does the student know who the governor is? *",
      formControlName: "governor",
    },
    {
      question: "Does the student know who the mayor is? *",
      formControlName: "mayor",
    },
  ]
  constructor() {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studentInterviewData'] && this.studentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    const group: any = {};

    group['student_counting'] = new FormControl(this.studentInterviewData?.student_counting || 'Good', Validators.required);
    
    this.questionList.forEach(question => {
      const defaultValue = this.studentInterviewData && this.studentInterviewData[question.formControlName] !== undefined
                           ? this.studentInterviewData[question.formControlName]
                           : this.yesNo.Yes;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
    });

    this.generalKnowledgeForm = new FormGroup(group);
  }

  saveGeneralKnowledge(): void {
    if (this.generalKnowledgeForm.invalid) {
      return;
    } else {
      this.onSaveSection7.emit(this.generalKnowledgeForm.value);
    }
  }

}
